var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 md12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm16: "", md16: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm16: "", md16: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.ubicacion.label,
                              items: _vm.ubicacionlist,
                              "item-text": "tipoubicaname",
                              "item-value": "tipoubicaid",
                              clearable: "",
                              required: ""
                            },
                            model: {
                              value: _vm.formFields.ubicacion.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.ubicacion, "value", $$v)
                              },
                              expression: "formFields.ubicacion.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: _vm.formFields.fechaingresoInicio.label,
                              "error-messages": _vm.errors.collect(
                                _vm.formFields.fechaingresoInicio.id
                              ),
                              id: _vm.formFields.fechaingresoInicio.id,
                              max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                            },
                            model: {
                              value: _vm.formFields.fechaingresoInicio.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.fechaingresoInicio,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.fechaingresoInicio.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: _vm.formFields.fechaingresoFin.label,
                              "error-messages": _vm.errors.collect(
                                _vm.formFields.fechaingresoFin.id
                              ),
                              id: _vm.formFields.fechaingresoFin.id,
                              max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                            },
                            model: {
                              value: _vm.formFields.fechaingresoFin.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.fechaingresoFin,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.fechaingresoFin.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.rut.label,
                              items: _vm.crm_rutlist,
                              "item-text": "asigcrm_rutcli",
                              "item-value": "asigcrm_rutcli",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.rut.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.rut, "value", $$v)
                              },
                              expression: "formFields.rut.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.requerimiento.label,
                              items: _vm.requermientoslist,
                              "item-text": "asigrequerimiento",
                              "item-value": "asigrequerimiento",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.requerimiento.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.requerimiento,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.requerimiento.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.TipoEquipo.label,
                              items: _vm.equiposlist,
                              "item-text": "tipoeqname",
                              "item-value": "tipoeqid",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.TipoEquipo.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.TipoEquipo,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.TipoEquipo.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.rack.label,
                              items: _vm.racklist,
                              "item-text": "moviserierack",
                              "item-value": "moviserierack",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.rack.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.rack, "value", $$v)
                              },
                              expression: "formFields.rack.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.Bloque.label,
                              items: _vm.bloquelist,
                              "item-text": "moviseriebloque",
                              "item-value": "moviseriebloque",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.Bloque.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.Bloque, "value", $$v)
                              },
                              expression: "formFields.Bloque.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c(
                            "v-btn",
                            { on: { click: _vm.handleBuscarClick } },
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v("Filtrar\n            ")
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            { on: { click: _vm.clearFilters } },
                            [
                              _c("v-icon", [_vm._v("clear")]),
                              _vm._v("Limpiar\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm3: "", md3: "" } }),
                      _c(
                        "v-flex",
                        { attrs: { sm1: "", md1: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.btn_exportar()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Exportar"), _c("br"), _vm._v("CSV")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleModal", {
            attrs: { params: _vm.params },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }